.stzh-pagecontent {
  @include grid;

  grid-template-areas:
    "aside-left aside-left aside-left aside-left"
    "content content content content";

  @include mq($from: medium) {
    grid-template-areas:
      "aside-left aside-left aside-left aside-left aside-left aside-left aside-left aside-left"
      "content content content content content content content content";
  }

  @include mq($from: large) {
    grid-template-areas:
      "aside-left aside-left aside-left aside-left aside-left aside-left aside-left aside-left aside-left aside-left aside-left aside-left"
      "content content content content content content content content content content content content";
  }

  &__aside-left {
    grid-area: aside-left;
  }

  &__content {
    grid-area: content;
  }

  &__anchornav {
    @include mq($to: large) {
      position: relative;
      top: 0px;
      left: 50%;
      right: 50%;
      margin-left: calc(-50vw + var(--stzh-scrollbar-width) / 2);
      margin-right: calc(-50vw + var(--stzh-scrollbar-width) / 2);
      width: calc(100vw - var(--stzh-scrollbar-width));
      max-width: calc(100vw - var(--stzh-scrollbar-width));
    }

    @include mq($from: large) {
      position: sticky;
      top: calc(
        var(--stzh-header-metabar-height, 0px) *
          var(--stzh-header-is-stuck, 0) + #{space("medium")}
      );
      transition: top $baseTransitionAnimationSpeed;
      width: calc(
        100% + #{$gridGutterLarge} - #{spaceCurveValue("large", "large")}
      );
    }

    @include mq($from: ultra) {
      width: calc(
        100% + #{$gridGutterUltra} - #{spaceCurveValue("large", "large")}
      );
    }
  }

  /* Has aside content */

  &--has-aside-left {
    @include mq($from: large) {
      // --stzh-textandimage-grid-template-columns: repeat(8, minmax(0, 1fr));
      // --stzh-textandimage-grid-template-areas:
      //   "text text text text image image image image";
      // --stzh-textandimage-small-grid-template-areas:
      //   "text text text text text image image image";
      // --stzh-textandimage-large-grid-template-areas:
      //   "text text text text text text . ."
      //   "image image image image image image image image";

      --stzh-content-grid-template-areas: "content content content content content content content content content content content content";

      grid-template-areas: "aside-left aside-left aside-left aside-left content content content content content content content content";
    }
  }

  &--has-aside-left &__aside-left {
    @include spaceCurve("margin-bottom", "section-inner");
  }

  /* Has no aside content */

  &--has-no-aside-left {
  }
}
